import { CALENDAR_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_CALENDARS = `${CALENDAR_SERVICE}/calendars`;

export const calendars = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: API_CALENDARS,
      method: "get",
      signal,
      params,
      filters,
      sort,
    });

    const response = await apiRequest(options);

    return response;
  },
  getById: async ({ id, signal } = {}) => {
    const options = await apiOptions({
      url: `${API_CALENDARS}/${id}`,
      method: "get",
      signal,
    });

    const response = await apiRequest(options);

    return response;
  },
  create: async ({ data, signal } = {}) => {
    const options = await apiOptions({
      url: API_CALENDARS,
      method: "post",
      signal,
      data,
    });

    const response = await apiRequest(options);
    return response;
  },
  update: async ({ id, data, signal, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_CALENDARS}/${id}`,
      method: "patch",
      signal,
      data: {
        ...data,
        settings: JSON.stringify(data.settings),
      },
    });

    const response = await apiRequest(options, toastMessageConfig);
    return response;
  },
  delete: async ({ id, modifiedOn, signal, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_CALENDARS}/${id}`,
      method: "delete",
      signal,
      data: { modifiedOn },
    });

    const response = await apiRequest(options, toastMessageConfig);
    return response;
  },
};
